import { useQuery } from "react-query";
import { getUserPermission } from "../../../../../actions/Utilities/ModuleManagement";

export const useGetUserPermission = (userId, enableGet) => {
  return useQuery(
    ["UserActivePermissions", userId],
    () => getUserPermission(userId),
    {
      enabled: enableGet,
      refetchOnWindowFocus: false,
    }
  );
};
